import Layout from "../../components/shared/layout/layout";
import Link from "next/link";
import ReactPlayer from "react-player";
import {Waypoint} from "react-waypoint";
import {useState} from "react";
import Seo from "../../components/shared/seo/seo";

const AutomaticPlayer = function(props) {
    let [shouldPlay, updatePlayState] = useState(false);

    let handleEnterViewport = function() {
        updatePlayState(true);
    }
    let handleExitViewport = function() {
        updatePlayState(false);
    }

    return (
        <Waypoint
            onEnter={handleEnterViewport}
            onLeave={handleExitViewport}>
            <div style={{width:"100%", height:"auto"}}>
            <ReactPlayer
                playing={shouldPlay}
                {...props}
            />
            </div>
        </Waypoint>
    )
}

export default function Geschichte(){
        return(
        <Layout>
            <Seo title="Geschichte" description="Die Geschichte des Weinguts Johann Gisperg." path="/weingut/geschichte" />
            <section className="background_light_texture no_fill small">
                <Link href="/weingut">
                    <p className="marker-back goBack annotation white"><b>Zurück</b></p>
                </Link>
                <h1 className="white center-text">Geschichte</h1>
            </section>
            <section className="background_light">
                <div className="col-12">
                    <p className="brown information" style={{letterSpacing:"1px"}}>Kapitel 1 - Prolog</p>
                    <h2 style={{marginBottom:0}}>Hauptstrasse 14</h2>
                    <p className="robertson brown" style={{marginTop:0}}>1690 bis 1942</p>
                    <p className="phrase brown col-4 center-text">Die Geschichte eines Teesdorfers Winzerhauses von Beginn an</p>
                </div>
                <div className="horizontal">
                    <div className="col-6 broad">
                         <img alt=""  style={{width:"100%"}} src="/images/geschichte/1690.webp" width="683" height="864"/>
                    </div>
                    <div className="col-6 broad" style={{justifyContent:"space-evenly"}}>
                        <div className="horizontal">
                            <p className="robertson size-50 brown">1690</p>
                            <p>Erster grundbürgerliche Eintrag des heutigen Weingutes in der Teesdorfer Hauptstraße, Eigentümer: Familie Hufnagel. </p>
                        </div>
                        <div className="horizontal">
                            <p className="robertson size-50 brown">1737</p>
                            <p>Erster urkundlicher Vermerk über eine geleistete Abgabe des Halblehenhauses Teesdorf 22 an die Herrschaft Leesdorf. </p>
                        </div>
                        <div className="horizontal">
                            <p className="robertson size-50 brown">1789</p>
                            <p>Eintrag im Grundbuch auf einen Weingarten und einen kleinen Weinvorrat. Von der Familie Hufnagel ging der Betrieb durch Heirat an Anna & Josef Lechner. </p>
                        </div>
                        <div className="horizontal">
                            <p className="robertson size-50 brown">1874</p>
                            <p>Deren Nachkommen Anne & Georg Lechner verkauften an Franziska & Johann Zöchling.</p>
                        </div>
                    </div>
                </div>
            </section>
            <section className="background_lighter">
                <div className="horizontal">
                    <div className="col-6 broad" style={{justifyContent:"space-evenly"}}>
                        <div className="horizontal">
                            <p className="robertson size-50 brown">1913</p>
                            <p>Verkauf und Übergabe des Betriebes an Sohn Lorenz Zöchling und dessen Frau Anna. Im Grundbuch schienen Weingartenparzellen in Teesdorf sowie in der KG Braiten (Harterberg) auf. Diese hatten 3 Töchter Hedwig, Hermine und Anna.  </p>
                        </div>
                        <div className="horizontal">
                            <p className="robertson size-50 brown">1941</p>
                            <p>Tochter Hedwig Zöchling übernahm während des 2. Weltkrieges den gemischten Betrieb und bewirtschaftete 18,44 ha Landwirtschaft und davon 0,5583 ha Weingärten. Im selben Jahr heiratet sie ihren Gatten Franz Wanzenböck, der beim Militär eingerückt war.  </p>
                        </div>
                        <div className="horizontal">
                            <p className="robertson size-50 brown">1942</p>
                            <p>Während der Kriegszeit kam Tochter Hedwig Wanzenböck, unsere heutige Seniorchefin, auf die Welt. Vater Franz hatte aufgrund einer Verwundung eine gewisse Zeit Heimaturlaub und konnte seiner Gattin im Betrieb helfen. Im selben Jahr musste er wieder an die Front. Eines der damals gekauften Fässer ist bis heute in Verwendung. </p>
                        </div>
                    </div>
                    <div className="col-6 broad">
                        <img alt=""  style={{width:"100%"}} src="/images/geschichte/1913.webp" width="807" height="1079"/>
                    </div>
                </div>
            </section>
            <section className="background_light">
                <div className="col-8">
                    <p className="information brown" style={{letterSpacing:"1px"}}>Kapitel 2</p>
                    <h2 className="center-text" style={{marginBottom:0}}>Kriegsende und Start einer Erfolgsgeschichte</h2>
                    <p className="robertson brown" style={{marginTop:0}}>1942 bis 1984</p>
                    <p className="phrase brown col-8 center-text">Wiederaufbau und Fundamente des Brugundermacherweingutes</p>
                </div>
                <div className="horizontal">
                    <div className="col-6 left">
                            <p className="robertson size-50 brown">1942 bis 1958</p>
                            <p>Franz Wanzenböck kam während des Krieges in französische Gefangenschaft, wo er bis zu seiner Entlassung (1946) auf einem großen Weingut tätig war. Von dort bracht er viele Ideen nach Hause, die aber in der Nachkriegszeit schwer umzusetzen waren. Hedwig und Franz arbeiteten tatkräftig am Beheben der Kriegsschäden, an der Verbesserung und Weiterentwicklung ihrer Lebensgrundlage.  Ihre Passion galt immer dem Weinbau. Tochter Hedwig wuchs bei Ihren Eltern und derer Freude am Weinbau auf, welche sie auch erbte, lernte von Kindheit an alle Tätigkeiten und war immer mit dabei. </p>
                    </div>
                    <div className="col-6 broad">
                        <img alt=""  style={{width:"100%"}} src="/images/geschichte/1942.webp" width="781" height="511"/>
                        <p className="narrow start-text" style={{alignSelf:"start", width:"60%"}}>In dieser Zeit wurden die Weingärten als Stockkultur bewirtschaftet. 1954 wurde ein Heurigenlokal erbaut.  Die Anlagen wurden in kleinen Schritten erweitert.
                            <br/><br/>
                            Der Wein wurde an Wirte und Händler im Fass verkauft. Durch diese Kontakte wurde mit der Abfüllung von 2l Flaschen begonnen, was zum Startschuss für den Ab Hof Verkauf wurde und zur steten Qualitätssteigerung führte. </p>
                    </div>
                </div>
            </section>
            <section className="background_lighter">
                <div className="col-12">
                    <p className="robertson brown">1958 bis 1959</p>
                </div>
                <div className="horizontal">
                    <div className="col-6 right start">
                        <p className="narrow" style={{width:"80%"}}>Hedwig besuchte im Winter die Weinbauschule in Gumpoldskirchen. Dort lernte Sie, dass die Sorte St. Laurent für trockene steinige Weingärten gut geeignet sei und überzeugte ihren Vater von einer Neuauspflanzung. Als 17-Jährige setzte sie sich auf ihr Moped, fuhr auf Empfehlung nach Baden zu einem bekannten Weinhauer, um sich von dort Veredelungsmaterial (Edelreiser) zu besorgen. </p>
                    </div>
                    <div className="col-6 left start">
                        <p className="narrow" style={{width:"80%"}}>Diese Reben wurden eigenhändig veredelt und in der Teesdorfer Riede Gestein (damals Gesteine) ausgepflanzt. Es war der erste St. Laurent Weingarten Teesdorfs. Erste Ausweitung der Rebflächen durch Ankauf der ersten Weingärten in Tattendorf. In den Weingärten waren damals Blauer Portugieser und Neuburger verbreitet.  </p>
                    </div>
                </div>
            </section>
            <section className="background_light">
                <div className="horizontal">
                    <div className="col-6 broad" style={{justifyContent:"space-evenly"}}>
                        <div className="horizontal">
                            <p className="robertson size-50 brown">1960</p>
                            <p>In diesen Jahren startete der Umstieg und Ausweitung auf die Hochkultur. Alteingesessene Sorten wurden dafür nicht empfohlen, sondern eher unbekannte Sorten wie Traminer, Muskat Ottonel, Müller-Thurgau, Weißburgunder, Ruländer, St. Laurent und Zweigelt. Zweigelt war anfangs nicht gut bekannt und konnte sich erst später durchsetzen. . Im Jahre 1962 fuhren wir die erste St.Laurent Ernte ein.</p>
                        </div>
                        <div className="horizontal">
                            <p className="robertson size-50 brown">1964</p>
                            <p>Heiratete„Hedi“ Hedwig Wanzenböck den ebenfalls aus einem landwirtschaftlichen teesdorfer Betrieb stammenden Johann Gisperg (geb. 1941). Dieser ist seit diesem Zeitpunkt im Betrieb tätig. Im selben Jahr kam Sohn Johann auf die Welt. Weiters wurde mühsam, händisch der bestehende Keller tiefer gegraben und befestigt.</p>
                        </div>
                    </div>
                    <div className="col-6 broad">
                        <img alt=""  style={{width:"100%"}} src="/images/geschichte/1960.webp" width="741" height="620"/>
                    </div>
                </div>
            </section>
            <section className="background_light">
                <div className="col-12">
                    <a utomaticPlayer muted={true} url="https://storagegisperg.blob.core.windows.net/bc-gisperg/videos/geschichte.mp4" height="400px" width="100%" controls={true}/>
                </div>
            </section>
            <section className="background_light">
                <div className="horizontal">
                    <div className="col-6 broad">
                        <img alt=""  style={{width:"100%"}} src="/images/geschichte/1964.webp" width="492" height="700"/>
                    </div>
                    <div className="col-6 left" style={{justifyContent:"space-evenly"}}>
                        <div>
                            <p className="robertson size-50 brown">1965</p>
                            <p>Ankauf zusätzlicher Weinfässer. Durch die Ernte in den neuen Weingärten war es möglich unseren langjährigen Ab Hof Kunden ein breiteres Sortiment anzubieten.</p>
                        </div>
                        <div>
                            <p className="robertson size-50 brown">1966 bis 1968</p>
                            <p>kamen die Töchter Ingrid und Gerda auf die Welt, die zwar nicht im Betrieb tätig sind, aber die familiäre Leidenschaft für Wein teilen. </p>
                        </div>
                    </div>
                </div>
            </section>
            <section className="background_lighter">
                <div className="horizontal">
                    <div className="col-6 broad left" style={{justifyContent:"space-evenly"}}>
                        <div>
                            <p className="robertson size-50 brown">1969 bis 1971</p>
                            <p>Vergrößerung des Heurigenlokals und Ausbau des heutigen Flaschenweinkellers und Wohngebäudes. Seit diesem Umbau hat die Straßenfront des Gebäudes seine heutige Form. Das damals geschaffene Sgraffito mit Weinbau Motiv ziert heute noch unsere Fassade.</p>
                        </div>
                        <div>
                            <p className="robertson size-50 brown">1971 bis 1972</p>
                            <p>Johann Gisperg sen. besuchte diverse Vorbereitungskurse und legte die Meisterprüfung für Weinbau und Keller ab.</p>
                        </div>
                        <div>
                            <p className="robertson size-50 brown">1970 bis 1975</p>
                            <p>Erneuerung und Ausweitung der Weingärten in Teesdorf und Tattendorf.</p>
                        </div>
                    </div>
                    <div className="col-6 broad">
                        <img alt=""  style={{width:"100%"}} src="/images/geschichte/1969.webp" width="812" height="979"/>
                    </div>
                </div>
            </section>
            <section className="background_light">
                <div className="horizontal">
                    <div className="col-6 broad">
                        <img alt=""  style={{width:"100%"}} src="/images/geschichte/1975.webp" width="621" height="993"/>
                    </div>
                    <div className="col-6 broad" style={{justifyContent:"space-evenly"}}>
                        <div className="horizontal">
                            <p className="robertson size-50 brown">1975</p>
                            <p>Nach Grundstückstausch mit der damaligen Großgemeinde Steinfelden (Blumau-Neurißhof, Günselsdorf, Tattendorf, Teesdorf) bekamen wir ein Weingartengrundstück auf der Ried Holzspur.</p>
                        </div>
                        <div className="horizontal">
                            <p className="robertson size-50 brown">1976</p>
                            <p>Bau des heutigen Fassweinkellers und Adjustierung des alten Rinderstahls zum Press- und Verarbeitungsraum. Dadurch verfügten wir erstmals über einen winterfesten Arbeitsraum. Das Teesdorfer Marterl wurde in diesem Jahr das erste Mal als Stichzeichnung auf den Weinetiketten verwendet. Noch heute findet es sich auf unseren Etiketten wieder.</p>
                        </div>
                    </div>
                </div>
            </section>
            <section className="background_lighter">
                <div className="horizontal">
                    <div className="col-6 broad" style={{justifyContent:"space-evenly"}}>
                        <div>
                            <p className="robertson size-50 brown">1978 & 1979</p>
                            <p>In zwei Teilübergaben wurde der Betrieb von Hedwig & Franz Wanzenböck an Hedwig & Johann Gisperg sen. weitergegeben. Im selben Zeitraum absolvierte deren Sohn Johann die HBLA in Klosterneuburg mit Matura und stieg anschließend in den Betrieb ein.</p>
                        </div>
                        <div>
                            <p className="robertson size-50 brown">1982</p>
                            <p>Gründung der Gemeinschaft der qualitätsorientierten Weinbau- und Kellermeister</p>
                        </div>
                    </div>
                    <div className="col-6 broad">
                        <img alt=""  style={{width:"100%"}} src="/images/geschichte/1978.webp" width="744" height="780"/>
                    </div>
                </div>
            </section>
            <section className="background_light">
                <div className="col-8">
                    <p className="information brown">Kapitel 3</p>
                    <h2 className="center-text" style={{marginBottom:0}}>Frostige Zeiten und <br/>grosser Fortschritt</h2>
                    <p className="robertson size-50 brown" style={{marginTop:0}}>1985 bis 2010</p>
                    <p className="brown phrase center-text">Vom gemischten landwirtschaftlichen Betrieb<br/> zum ausgezeichneten Weingut</p>
                    <img alt=""  style={{width:"100%"}} src="/images/geschichte/1985.webp" width="808" height="420"/>
                </div>
                <div className="horizontal">
                    <div className="col-6">
                        <p className="size-50 robertson brown left start">1985</p>
                    </div>
                    <div className="col-6"></div>
                </div>
                    <div className="horizontal">
                        <p className="col-6">In den Monaten Jänner, Februar und März fielen die Temperaturen unter -20°C. Bei diesen tiefen Temperaturen erfroren die oberirdischen Teile der Weinstöcke. Im darauffolgenden Frühjahr und Sommer trieben die Stöcke aus dem unteren Bereich teilweise wieder aus. Um die Reben zu retten, musste mit mühevollem persönlichem Aufwand die grünen Triebe angebunden und gepflegt werden. In diesem Jahr brachten diese keinen Ertrag. </p>
                        <p className="col-6">Dank einiger Weinvorräte aus dem Vorjahr konnte ein Teil der langjährigen Kunden weiter beliefert werden. Die zweite Katastrophe in diesem Jahr war der allseits bekannte Weinskandal. Er brachte große Unsicherheiten, falsche Beschuldigungen und einen großen Vertrauensverlust gegenüber der gesamten Branche. Viele unbeteiligte Betriebe bekamen dies ebenfalls über Jahre zu spüren. Im Alter von 72 Jahren verstarb unser Großvater Franz Wanzenböck. </p>
                    </div>
            </section>
            <section className="background_lighter">
                <div className="horizontal">
                    <div className="col-6 broad">
                        <img alt=""  style={{width:"100%"}} src="/images/geschichte/1986.webp" width="579" height="754"/>
                    </div>
                    <div className="col-6 broad" style={{justifyContent:"space-evenly"}}>
                        <div className="horizontal">
                            <p className="robertson size-50 brown">1986</p>
                            <p>Nachdem im Vorjahr viele Triebe hochgezogen wurden, konnte in diesem Jahr eine kleine Ernte eingefahren werden. Erstmaliges Auspflanzen von Pinot Noir auf der Ried Holzspur (ehem. Mitterfeld).</p>
                        </div>
                        <div className="horizontal">
                            <p className="robertson size-50 brown">1987</p>
                            <p>erging es uns wieder wie 1985. Die jungen und teilweise schlecht ausgereiften Triebe hielten die Fröste um -20°C nicht aus. Das Jahr war wieder geprägt von viel Handarbeit ohne Lese. In diesem Jahr wuchs der Betrieb um 1,54 ha in Teesdorf und Tattendorf.</p>
                        </div>
                        <div className="horizontal">
                            <p className="robertson size-50 brown">1988</p>
                            <p>Erstmaliger Einsatz von Barrique für die Sorte Cabernet Sauvignon; Erster gezielter biologischer Säureabbau.</p>
                        </div>
                        <div className="horizontal">
                            <p className="robertson size-50 brown">1989</p>
                            <p>Heirat von Johann Gisperg (geb. 1964) & Erika Seitz. Diese war zu diesem Zeitpunkt schon im Betrieb mit tätig. Neugestaltung Etikett.</p>
                        </div>
                    </div>
                </div>
            </section>
            <section className="background_light small">
                <div className="col-3">
                    <p className="size-50 robertson brown" style={{marginBottom:0}}>1990 bis 1994</p>
                    <p className="narrow">Umbau des Heurigenlokals, Geburt der Kinder Petra, Johann und Christian, Erstmalige Reduktion der Trauben. Erster PC im Weingut.</p>
                </div>
            </section>
            <section className="background_lighter">
                <div className="horizontal">
                    <div className="col-6 broad" style={{justifyContent:"space-evenly"}}>
                        <div className="horizontal">
                            <p className="robertson size-50 brown">1996</p>
                            <p>Verstarb um Alter von 83 Jahren unsere (Ur-)Großmutter Hedwig Wanzenböck sen.</p>
                        </div>
                        <div className="horizontal">
                            <p className="robertson size-50 brown">1998</p>
                            <p>Abriss der Scheune und Neubau des heutigen Fasskellers und Presshauses.</p>
                        </div>
                        <div className="horizontal">
                            <p className="robertson size-50 brown">1999</p>
                            <p>Eröffnung des neuen Kellers im Zuge des ersten „Wein erleben“.</p>
                        </div>
                    </div>
                    <div className="col-6 broad">
                        <img alt=""  style={{width:"100%"}} src="/images/geschichte/1996.webp" width="650" height="510"/>
                    </div>
                </div>
            </section>
            <section className="background_light">
                <div className="horizontal">
                    <div className="col-6 broad">
                        <img alt=""  style={{width:"100%"}} src="/images/geschichte/2003.webp" width="609" height="408"/>
                    </div>
                    <div className="col-6 broad" style={{justifyContent:"space-evenly"}}>
                        <div className="horizontal">
                            <p className="robertson size-50 brown">2003</p>
                            <p>Gründung der Burgundermacher. Auspflanzung von St. Laurent auf der Ried Rotes Kreuz, Umstellung von Lesewagen auf Kistenlese</p>
                        </div>
                        <div className="horizontal left">
                            <p className="robertson size-50 brown">2004</p>
                            <p>Einführung der Reserve Kategorie.</p>
                        </div>
                        <div className="horizontal">
                            <p className="robertson size-50 brown">2008</p>
                            <p>Erweiterung der Rebfläche in Tattendorf & Teesdorf – aus Tante Klaras Weingarten entsteht der Gemischte Satz „Klara“.</p>
                        </div>
                    </div>
                </div>
            </section>
            <section className="background_lighter">
                <div className="col-6">
                    <p className="information brown">Kapitel 4</p>
                    <h2 className="center-text" style={{marginBottom:0}}>Innovativ<br/> Tradition gestalten</h2>
                    <p className="robertson size-50 brown" style={{marginTop:0}}>seit 2011</p>
                    <p className="phrase brown center-text">Ein verjüngtes Team auf dem Weg zur österreichischen Burgunderspitze</p>
                </div>
                <div className="horizontal">
                    <div className="col-6 broad">
                        <img alt=""  style={{width:"100%"}} src="/images/geschichte/2011.webp" width="489" height="412"/>
                    </div>
                    <div className="col-6 broad" style={{justifyContent:"space-evenly"}}>
                        <div>
                            <p className="robertson size-50 brown">2011 bis 2012</p>
                            <p>Johann (1992) absolviert und maturiert in der HBLA Klosterneuburg, steigt in den Betrieb ein und übernimmt im darauffolgenden Jahr die Verantwortung im Keller. Im selben Jahr kreierte er seinen ersten Kontrast (JG 2009) Traubenübernahme mit Sortierung </p>
                        </div>
                    </div>
                </div>
            </section>
            <section className="background_light small">
                <div className="horizontal">
                    <div className="col-6 broad" style={{justifyContent:"space-evenly"}}>
                        <div className="horizontal">
                            <p className="robertson size-50 brown">2014</p>
                            <p>Erweiterung der Pinot Noir Fläche in Tattendorf (Ried Holzspur)<br/> Österreichweit schwieriger & sehr feuchter Jahrgang – dennoch sehr gute Weinqualität im Weingut aufgrund geologischer & klimatischer Vorteile der Region in regnerischen Jahrgängen. Mit dem 2014er Pinot Noir wurde man später Falstaffsieger.</p>
                        </div>
                        <div className="horizontal left">
                            <p className="robertson size-50 brown">2015</p>
                            <p>Erstmalig Zweigelt und Chardonnay im Topsegment (Reserve)</p>
                        </div>
                    </div>
                    <div className="col-6 broad">
                        <img alt=""  style={{width:"100%"}} src="/images/geschichte/2014.webp" width="514" height="552"/>
                    </div>
                </div>
            </section>
            <section className="background_lighter">
                <div className="horizontal">
                    <div className="col-6 broad">
                        <img alt=""  style={{width:"100%"}} src="/images/geschichte/2016.webp" width="749" height="922"/>
                    </div>
                    <div className="col-6 broad">
                        <div>
                            <p className="robertson size-50 brown">2016 bis 2017</p>
                            <p>Im April rückten die Winzer Teesdorfs und Tattendorfs aus, die Weingärten vor den drohenden Spätfrösten zu schützen.
                                <br/><br/>
                                In mehreren Nächten wurden gegen Mitternacht die Rauchstellen (mit Wasser getränktes Stroh) entlang der Weingärten entzündet um bis zum Absinken der Temperatur auf 0°C eine flächendeckende Rauch-Dampfdecke zu bilden. Diese verhindert das Ausstrahlen der Bodenwärme und somit ein Abkühlen der Luft in Bodennähe - sogenannten Strahlungsfrost Zusätzlich wurde in den Morgenstunden die Unterstützung durch Hubschrau­ber in Anspruch genommen, um die warme Luft von oberen Luftschichten nach unten zu wirbeln.
                                <br/><br/>
                                Weiters konnten einzelne Flächen mit einer Frostberegnung geschützt werden. Durch den Einsatz konnte der Großteil vor Schäden bewahrt werden. Im Sommer wurde Lagerfläche mittels eines Vollgutlagers erweitert. </p>
                        </div>
                    </div>
                </div>
            </section>
            <section className="background_light">
                <div className="horizontal">
                    <div className="col-6 broad" style={{justifyContent:"space-evenly"}}>
                        <div className="horizontal">
                            <p className="robertson size-50 brown">2017</p>
                            <p>Relaunch der Weinetiketten unter dem Motto „Tradition & Innovation im Einklang“ – das seit 1976 bestehende „Marterl-Logo“ bleibt auch beim zweiten Relaunch erhalten.</p>
                        </div>
                        <div className="horizontal">
                            <p className="robertson size-50 brown">2020</p>
                            <p>Estmalig Weißburgunder und Pinot Gris im Top Segment ausgebaut. Einführung der Riedenweine (JG 2019) mit den Weinen aus der Riede Gestein und Holzspur.</p>
                        </div>
                        <div className="horizontal">
                            <p className="robertson size-50 brown">2021</p>
                            <p>Geburt von Tochter Leonie Gisperg. Einführung der Herkunftspyramide. Erweiterung der von Pinot Noir und St. Laurent Flächen auf der Ried Holzspur und Weißes Kreuz.</p>
                        </div>
                        <div className="horizontal">
                            <p className="robertson size-50 brown">2022</p>
                            <p>Jahr der Jubiläen - Wir feiern 30 Jahre Johann Gisperg jun. | 10 Jahre Kellermeister | 80 Jahre Hedwig Gisperg und die 60ste St.Laurent Ernte</p>
                        </div>
                        <p className="robertson size-50 brown">To be continued ...</p>
                    </div>
                    <div className="col-6 broad">
                        <img alt=""  style={{width:"100%", marginTop:"-100px"}} src="/images/geschichte/2017.webp" width="644" height="885"/>
                    </div>
                </div>
            </section>
        </Layout>
    )
}